import type { TOrganizationAsideContacts } from '~/components/widget/organization-aside-contacts'
import type { IOrganization } from '~/components/entity/organization/types'

export function mapBankToOrganizationInfo(
  bank: IOrganization | undefined
): TOrganizationAsideContacts | null {
  if (!bank) return null

  return {
    title: bank.title,
    call_center_phone: bank.call_center_phone,
    email: bank.email,
    logo: bank.logo,
    website_url: bank.website_url,
    head_branch_location: bank.head_branch_location,
    official_title: bank.official_title,
    options: {
      islamic: bank.options?.islamic || false,
      deposits_protected: bank.options?.deposits_protected || false
    }
  }
}
